"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperiencedMartians = void 0;
const Tags_1 = require("../../Tags");
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Resources_1 = require("../../../Resources");
const SendDelegateToArea_1 = require("../../../deferredActions/SendDelegateToArea");
const CardRenderer_1 = require("../../render/CardRenderer");
const Units_1 = require("../../../Units");
class ExperiencedMartians extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.EXPERIENCED_MARTIANS,
            tags: [Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ plants: 1, heat: 1 }),
            metadata: {
                cardNumber: 'Y10',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(2).br;
                    b.production((pb) => {
                        pb.plants(1).heat(1);
                    });
                }),
                description: 'Place 2 delegates in any one party. Increase your plant and heat production 1 step.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.HEAT);
        player.addProduction(Resources_1.Resources.PLANTS);
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send 2 delegates', { count: 2, source: 'reserve' }));
        return undefined;
    }
}
exports.ExperiencedMartians = ExperiencedMartians;
//# sourceMappingURL=ExperiencedMartians.js.map